import React, {FC, useEffect, useState} from 'react'
import {KTSVG} from '../../_metronic/helpers'
import {StatusInterface} from './types'
import {useSpring, animated} from '@react-spring/web'

const Status: FC<StatusInterface> = ({status, color, message, icon}) => {

  const [visibleStatus, setVisibleStatus] = useState(status)

  useEffect(() => {
    if (status > 0) {
      setVisibleStatus(status)

      const timer = setTimeout(() => {
        setVisibleStatus(-1)
      }, 2000)

      return () => clearTimeout(timer)
    }
  }, [status])

  const opacity = visibleStatus > 0 ? 1 : 0
  const transform = visibleStatus > 0 ? 'translateX(0px)' : 'translateX(-20px)'

  const springs = useSpring({
    opacity,
    transform,
    config: {tension: 170, friction: 26},
  })

  if (visibleStatus <= 0) return <></>

  return (
    <animated.div style={springs} className="my-3">
      <div className={`alert alert-${color} d-flex align-items-center p-3 mb-0`}>
        <span className={`svg-icon svg-icon-2hx svg-icon-${color} me-4`}>
          <KTSVG path={`/media/icons/duotune${icon}`} className="svg-icon-2x" />
        </span>
        <div className="d-flex flex-column">
          <span>{message}</span>
        </div>
      </div>
    </animated.div>
  )
}

export {Status}
